import React from "react";

type Props = {
  pickupReadiness: boolean;
};

const PickupLabel: React.FC<Props> = ({ pickupReadiness }) => {
  const label = pickupReadiness ? "Pickup in under 30 mins" : "Pickup";

  return (
    <div className="flex items-center bg-leafly-white rounded px-sm text-xs">
      <div className="flex items-center justify-center">
        <span className="font-bold">{label}</span>
      </div>
    </div>
  );
};

export default PickupLabel;
